import { render, staticRenderFns } from "./prepareCurriculum.vue?vue&type=template&id=d3a2f7f4&scoped=true"
import script from "./prepareCurriculum.vue?vue&type=script&lang=js"
export * from "./prepareCurriculum.vue?vue&type=script&lang=js"
import style0 from "./prepareCurriculum.vue?vue&type=style&index=0&id=d3a2f7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a2f7f4",
  null
  
)

export default component.exports